import { styled } from '@mui/material';
import { SxProps, Theme } from '@mui/system';
import { PolicyStreamPlan } from './PolicyStreamPlanSelectionPage';

interface PolicyStreamPlanIconProps {
  insurer: PolicyStreamPlan['insurer'];
  sx?: SxProps<Theme>;
}
export const PolicyStreamPlanIcon = ({
  insurer,
  sx,
}: PolicyStreamPlanIconProps) => {
  return insurer.logoUrl ? (
    <IconImg
      src={insurer.logoUrl}
      alt={`Icon for ${insurer.displayName}`}
      sx={sx ? sx : undefined}
    />
  ) : null;
};

const IconImg = styled('img')({});
